module.exports = __webpack_public_path__ + "img/online_certificate.e59a6449.png";